var exports = {
  "k": "xa15a2ab7--023070--container",
  "D": "xa15a2ab7--023070--title",
};

module.exports = exports;
